<template>
  <el-dialog :title="title" :visible.sync="visible" width="60%">
    <div style="overflow-y: auto; height: 600px; padding: 25px">
      <el-form
        label-width="150px"
        label-position="left"
        class="formPage"
        style="overflow-y: auto"
      >
        <el-form-item
          v-for="(item, index) in data1"
          :label="item.key"
          class="form-item-full"
          :key="index"
          style="width: 100%; justify-content: center"
        >
          <span>{{ item.value }}</span>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" :disabled="btnDisabled" @click="callbackOk">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      isSubmit: false,
      title: '信息确认',
      data1: [],
      //初始值为false
      btnDisabled: false,
    }
  },
  methods: {
    callbackOk() {
      this.btnDisabled = true;
      this.isSubmit = true
      this.$nextTick(() => {
        this.visible = false
      })
       this.btnDisabled = false;
    },
    handleCancel() {
      this.isSubmit = false
      this.$nextTick(() => {
        this.visible = false
      })
    },
  },
}
</script>
<style scoped>
.msak {
  position: absolute;
  z-index: 9998;
  background: #333;
  width: 100%;
  height: 1000px;
  opacity: 0.8;
}
.msak h3 {
  left: 50%;
  top: 50%;
  position: absolute;
  z-index: 9999;
  color: #fff;
}
</style>
